import { useDispatch } from "react-redux";
import { handlePlayerDealVoteRequest, handlePlayerICMDealVoteRequest } from "../../../Poker/redux/slices/gameTableSlice";
import useActiveGame from "../data/useActiveGame";
import { useGameDefinition, useTourneyPlayerRankDetails, usePlayerSeat as useGamePlayerSeat, useDealObject, useDealICMObject, useTableId } from "../data/useGameTable";
import usePlayerDetails from "../data/usePlayerDetails";
import usePlayerSeat from "../data/usePlayerSeat";
import useGameSocket from "./useGameSocket";
import useActiveGames from "../data/useActiveGames";
import { useNavigate } from "react-router";

export default function useTourneyDealMaking(tempTableId)  {

    const gameDefinition = useGameDefinition(tempTableId);
    const tourneyPlayerRankDetails = useTourneyPlayerRankDetails(tempTableId);
    const playerSeat = useGamePlayerSeat(tempTableId);
    const dealObject = useDealObject(tempTableId);
    const dealICMObject = useDealICMObject(tempTableId);
    const tableId = useTableId(tempTableId);
    const { atTableAmount } = usePlayerSeat(tempTableId, playerSeat);
    const { userName, channel } = usePlayerDetails();
    const activeGames = useActiveGames();
    const navigate = useNavigate();
    const { sendDealVoteRequest, sendDealICMVoteRequest, triggerExitTableFlow } = useGameSocket(tempTableId);

    const dispatch = useDispatch();

    const handleDealClick = () => {
        let temp = new Date();
        let timeStamp = new Date(temp.getTime() + 330 * 60 * 1000);
        timeStamp = timeStamp.toISOString();
        if (!dealObject?.pendingAck) {
            // let params = {
            //     "Tourney Name": gameDefinition?.tourneyName,
            //     "Tourney rank": tourneyPlayerRankDetails?.playerRank,
            //     "Current stack": atTableAmount,
            //     "Timestamp": timeStamp,
            //     "Username": userName,
            //     "Channel": channel,
            //     "Deal Vote" : !dealObject?.dealOpted === true ? "YES" : "NO",
            // };
            // plotlineEventCallbackToNative(PR_Tourney_InitiateDeal, params);
            // logCleverTapEvent(PR_Tourney_InitiateDeal, params);

            sendDealVoteRequest({
                opted: !dealObject?.dealOpted,
                tourneyId: gameDefinition?.tourneyId
            })
            dispatch(
                handlePlayerDealVoteRequest({
                    tempTableId: tempTableId,
                })
            );
        }
    };


    const logPlotlineAndCTEvents = (eventType) => {
        let temp = new Date();
        let timeStamp = new Date(temp.getTime() + 330 * 60 * 1000);
        timeStamp = timeStamp.toISOString();

        let params = {
            "Tourney Name": gameDefinition?.tourneyName,
            "Tourney rank" : tourneyPlayerRankDetails?.playerRank,
            "Current stack": atTableAmount,
            "Timestamp": timeStamp,
            "Username": userName,
            "Channel": channel,
            "status" : eventType,
        }
        plotlineEventCallbackToNative("PR_TourneyDeal_Click", params);
        logCleverTapEvent("PR_TourneyDeal_Click", params);

    }

    const onAcceptButtonClick = () => {
        if(!dealICMObject?.pendingAck){
            // logPlotlineAndCTEvents("Accept");
            sendDealICMVoteRequest({
                playerName: userName,
                tourneyId: gameDefinition?.tourneyId,
                vote: true,
            });
            dispatch(handlePlayerICMDealVoteRequest({
                tempTableId: tempTableId,
                status: true,
            }));
        }
        
    }

    const onRejectButtonClick = () => {
        if(!dealICMObject?.pendingAck){
            // logPlotlineAndCTEvents("Reject");
             sendDealICMVoteRequest({
                playerName: userName,
                tourneyId: gameDefinition?.tourneyId,
                vote: false,
            });
            dispatch(handlePlayerICMDealVoteRequest({
                tempTableId: tempTableId,
                status: false,
            }));
        }
        
    }

    const handleGoToLobby = () => {
        if (activeGames.length === 1) {
            navigate(-1, { replace: true });
        }
        triggerExitTableFlow();
    }

    return {
        handleDealClick,
        onAcceptButtonClick,
        onRejectButtonClick,
        handleGoToLobby,
    };
}
 
